import { PhosphorCalendarBlank } from "components/Atoms/PhosphorIcon";
import React from "react";
import { getExternalEventHeaderTitle } from "shared/utils/purpleHeaderUtils";
import { EventHeaderLayout } from "./EventHeaderLayout";

interface ExternalEventHeaderProps {
  externalEvent: server.dto.ExternalEvent
}

export const ExternalEventHeader = ({ externalEvent }: ExternalEventHeaderProps) =>
  <EventHeaderLayout
    icon={<PhosphorCalendarBlank iconColor="white" iconSize="large" />}
    tourName={undefined}
    title={getExternalEventHeaderTitle(externalEvent)}
    subtitle={undefined}
    location={externalEvent.location}
    dateTime={externalEvent.dateTime}
    attendees={[]}
    artist={externalEvent.artist}
  />;
